import { jsx as _jsx } from "react/jsx-runtime";
export function ArrowDropUpIcon({ size, className }) {
    return (_jsx("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", height: size + 'px', viewBox: "0 -960 960 960", width: size + 'px', children: _jsx("path", { d: "M293.69-406 480-590.31 666.31-406H293.69Z" }) }));
}
//# sourceMappingURL=ArrowDropUpIcon.js.map